/**
 * Invitation-gated confirmation mail uses GoTrue POST /auth/v1/resend
 * (type=signup). admin.generateLink only mints a link; it does not send mail.
 */

export type ConfirmationResendPayload = {
  success?: boolean;
  resent?: boolean;
  error?: string;
  code?: string;
};

export function buildGoTrueSignupResendUrl(supabaseUrl: string, redirectTo: string): string {
  const base = supabaseUrl.replace(/\/+$/, "");
  return `${base}/auth/v1/resend?redirect_to=${encodeURIComponent(redirectTo)}`;
}

export function invitationConfirmationResendAccepted(
  payload: ConfirmationResendPayload | null | undefined,
  invokeError: { message?: string } | null | undefined,
): boolean {
  if (invokeError) return false;
  if (payload?.code === "ALREADY_CONFIRMED" || payload?.code === "RATE_LIMITED") return false;
  return payload?.success === true && payload?.resent === true;
}

export function interpretGoTrueSignupResendHttp(
  httpStatus: number,
  bodyText: string,
): { ok: true } | { ok: false; code: "RATE_LIMITED" | "SEND_FAILED"; error: string } {
  const text = bodyText ?? "";
  if (httpStatus === 429 || /rate.?limit|too many|over_email_send_rate_limit/i.test(text)) {
    return {
      ok: false,
      code: "RATE_LIMITED",
      error: "Please wait a moment before requesting another confirmation email.",
    };
  }
  if (httpStatus < 200 || httpStatus >= 300) {
    return { ok: false, code: "SEND_FAILED", error: "Unable to send confirmation email." };
  }
  return { ok: true };
}
